var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "profile_entry"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h2", null, "基本情報確認", -1);
const _hoisted_5 = { class: "inner" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "メール", -1);
const _hoisted_7 = { class: "dd_l" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "表示名", -1);
const _hoisted_9 = { class: "dd_l" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "パスワード", -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("dd", { class: "dd_l" }, "＊＊＊＊＊＊＊＊", -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "業種", -1);
const _hoisted_13 = { class: "dd_l" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "職種", -1);
const _hoisted_15 = { class: "dd_l" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "会社概要", -1);
const _hoisted_17 = {
    class: "dd_l",
    style: { "white-space": "pre-line" }
};
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "年商", -1);
const _hoisted_19 = { class: "dd_l" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "社員数", -1);
const _hoisted_21 = { class: "dd_l" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, "料金プラン", -1);
const _hoisted_23 = { class: "tab-wrap check" };
const _hoisted_24 = { class: "form-plan tab-content" };
const _hoisted_25 = { class: "plan-title" };
const _hoisted_26 = { class: "plan-main" };
const _hoisted_27 = { class: "plan-main-top" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("p", null, "基本料金(月額)", -1);
const _hoisted_29 = { class: "plan-money" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("span", { class: "plan-type" }, "円(税込)", -1);
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("div", { class: "plan-main-top" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "基本料金(月額)")
], -1);
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("p", { class: "plan-money" }, [
    /*#__PURE__*/ _createTextVNode("無料"),
    /*#__PURE__*/ _createElementVNode("span", { class: "plan-type" }, "(相談は不可)")
], -1);
const _hoisted_33 = {
    key: 0,
    class: "plan-add"
};
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("p", null, "追加相談", -1);
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("div", { class: "plan-article" }, [
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createTextVNode("※日割りできないので、初月の基本料金は、申込日に応じて次の対応とさせて頂きます。"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode(" 申込日が1～15日：基本料金を全額支払い（質問チケットは基本と同数）"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode(" 申込日が16～末日：基本料金を半額支払い（質問チケットは基本の半数）")
    ])
], -1);
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("p", { class: "plan-alart" }, "※このお申込後に、キャンセルすることはできません。", -1);
const _hoisted_37 = { class: "bt_box" };
const _hoisted_38 = ["onClick"];
import { ref, computed, onBeforeMount } from 'vue';
import axios from 'axios';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import InertiaUtil from '@util/InertiaUtil';
import { PlanCategory } from '@util/Consts';
export default /*#__PURE__*/ _defineComponent({
    __name: 'profile_check',
    props: {
        common: null,
        form: null
    },
    setup(__props) {
        const props = __props;
        const form = InertiaUtil.getForm({
            name: props.form.name,
            email: props.form.email,
            password: props.form.password,
            password_confirmation: props.form.password_confirmation,
            industry_id: props.form.industry_id,
            job_id: props.form.job_id,
            job_group_id: props.form.job_group_id,
            other_job_name: props.form.other_job_name,
            company_profile: props.form.company_profile,
            annual_sale_id: props.form.annual_sale_id,
            employee_id: props.form.employee_id,
            plan_id: props.form.plan_id,
        }, props.common.path);
        const industryOptions = ref([]);
        const jobOptions = ref([]);
        const annualSaleOptions = ref([]);
        const employeesOptions = ref([]);
        const planOptions = ref([]);
        const showRegisterLabel = computed(() => {
            return form.plan_id === PlanCategory.FREE_PLAN ? '登録' : '支払方法登録';
        });
        const showIndustry = computed(() => {
            return getName(form.industry_id, industryOptions.value);
        });
        const showJob = computed(() => {
            if (form.job_id) {
                let job = undefined;
                const group = jobOptions.value.find(value => {
                    job = value.jobs.find(val => val.id === form.job_id);
                    return job !== undefined;
                });
                if (job && group) {
                    return `${group.name} > ${job.name}`;
                }
            }
            else if (form.other_job_name) {
                return `その他 > ${form.other_job_name}`;
            }
            return '';
        });
        const showAnnualSale = computed(() => {
            return getName(form.annual_sale_id, annualSaleOptions.value);
        });
        const showEmployee = computed(() => {
            return getName(form.employee_id, employeesOptions.value);
        });
        const plan = computed(() => {
            var _a;
            const option = (_a = planOptions.value.find(value => value.id === form.plan_id)) !== null && _a !== void 0 ? _a : null;
            return option;
        });
        const getName = (id, options) => {
            var _a, _b;
            const option = (_a = options.find(value => value.id === id)) !== null && _a !== void 0 ? _a : null;
            return (_b = option === null || option === void 0 ? void 0 : option.name) !== null && _b !== void 0 ? _b : '';
        };
        const onClickReturn = () => {
            window.history.back();
        };
        const onSend = () => {
            InertiaUtil.post(form, route('questioner.register.store'));
        };
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            const [industries, jobs, annualSales, employees, plans] = yield Promise.all([
                axios.get('industries').then(res => res.data).catch(e => []),
                axios.get('jobs').then(res => res.data).catch(e => []),
                axios.get('annual-sales').then(res => res.data).catch(e => []),
                axios.get('employees').then(res => res.data).catch(e => []),
                axios.get('plans').then(res => res.data).catch(e => []),
            ]);
            industryOptions.value = industries;
            jobOptions.value = jobs;
            annualSaleOptions.value = annualSales;
            employeesOptions.value = employees;
            planOptions.value = plans;
        }));
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("form", null, [
                                    _createElementVNode("dl", null, [
                                        _hoisted_6,
                                        _createElementVNode("dd", _hoisted_7, _toDisplayString(_unref(form).email), 1),
                                        _hoisted_8,
                                        _createElementVNode("dd", _hoisted_9, _toDisplayString(_unref(form).name), 1),
                                        _hoisted_10,
                                        _hoisted_11,
                                        _hoisted_12,
                                        _createElementVNode("dd", _hoisted_13, _toDisplayString(_unref(showIndustry)), 1),
                                        _hoisted_14,
                                        _createElementVNode("dd", _hoisted_15, _toDisplayString(_unref(showJob)), 1),
                                        _hoisted_16,
                                        _createElementVNode("dd", _hoisted_17, _toDisplayString(_unref(form).company_profile), 1),
                                        _hoisted_18,
                                        _createElementVNode("dd", _hoisted_19, _toDisplayString(_unref(showAnnualSale)), 1),
                                        _hoisted_20,
                                        _createElementVNode("dd", _hoisted_21, _toDisplayString(_unref(showEmployee)), 1),
                                        _hoisted_22,
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                    _createElementVNode("p", _hoisted_25, _toDisplayString(`${(_b = (_a = _unref(plan)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ''}プラン`), 1),
                                                    _createElementVNode("div", _hoisted_26, [
                                                        (((_c = _unref(plan)) === null || _c === void 0 ? void 0 : _c.id) !== _unref(PlanCategory).FREE_PLAN)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createElementVNode("div", _hoisted_27, [
                                                                    _hoisted_28,
                                                                    _createElementVNode("p", null, "(相談" + _toDisplayString((_d = _unref(plan)) === null || _d === void 0 ? void 0 : _d.monthly_question_count) + "件以内/月)", 1)
                                                                ]),
                                                                _createElementVNode("p", _hoisted_29, [
                                                                    _createTextVNode(_toDisplayString((_g = ((_f = (_e = _unref(plan)) === null || _e === void 0 ? void 0 : _e.monthly_amount) !== null && _f !== void 0 ? _f : 0)) === null || _g === void 0 ? void 0 : _g.toLocaleString()), 1),
                                                                    _hoisted_30
                                                                ])
                                                            ], 64))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _hoisted_31,
                                                                _hoisted_32
                                                            ], 64))
                                                    ]),
                                                    ((_h = _unref(plan)) === null || _h === void 0 ? void 0 : _h.is_allowed_additional_question)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                            _hoisted_34,
                                                            _createElementVNode("p", null, _toDisplayString((_l = ((_k = (_j = _unref(plan)) === null || _j === void 0 ? void 0 : _j.additional_question_amount) !== null && _k !== void 0 ? _k : 0)) === null || _l === void 0 ? void 0 : _l.toLocaleString()) + "円 / 件(税込)", 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (((_m = _unref(plan)) === null || _m === void 0 ? void 0 : _m.id) !== _unref(PlanCategory).FREE_PLAN)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _hoisted_35,
                                                            _hoisted_36
                                                        ], 64))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    id: "submit-button",
                                                    onClick: onClickReturn,
                                                    class: "bt_back"
                                                }, " 戻る ")
                                            ]),
                                            _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    id: "submit-button",
                                                    onClick: _withModifiers(onSend, ["prevent"])
                                                }, _toDisplayString(_unref(showRegisterLabel)), 9, _hoisted_38)
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
